import React from 'react';
import * as PropTypes from 'prop-types';

import { scrollTo } from '../utils';

const propTypes = {
  children: PropTypes.any,
  disabledTagName: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
  isDisabled: PropTypes.bool,
  href: PropTypes.string,
  id: PropTypes.string,
  className: PropTypes.string,
  title: PropTypes.string,
  data: PropTypes.any,
  onClick: PropTypes.func,
};

const defaultProps = {
  children: null,
  disabledTagName: 'div',
  isDisabled: false,
  href: '',
  data: '',
  onClick: () => null,
  id: '',
  className: '',
  title: '',
};

// DOCS https://github.com/fisshy/react-scroll
const SmoothScrollAnchor = (props) => {
  const { href, children, isDisabled, disabledTagName, id, className, title, data, onClick } =
    props;

  const DisabledTagName = disabledTagName;

  if (isDisabled) {
    return <DisabledTagName {...props}>{children}</DisabledTagName>;
  }

  const scroll = (to, time) => {
    scrollTo(to, time);
    setTimeout(() => onClick(), time);
  };

  return (
    <a
      role="button"
      onClick={() => scroll(href, 550)}
      id={id}
      className={className}
      data={data}
      title={title}
    >
      {children}
    </a>
  );
};

SmoothScrollAnchor.propTypes = propTypes;
SmoothScrollAnchor.defaultProps = defaultProps;

export default SmoothScrollAnchor;
